import { useApolloClient } from "@apollo/client";
import React from "react";
import type { DecisionBehaviorOfSubitems } from "../../../clients/graphqlTypes.js";
import { useChangeDecisionMutation } from "../doc-items/hooks/useDecisionItemMutations.generated.js";

interface Options {
  projectId: string | null;
  docId: string;
}

export type SetDecisionBehaviorFn = (
  itemId: string,
  value: DecisionBehaviorOfSubitems
) => Promise<void>;

export function useDecisionBehaviorToggle({ projectId, docId }: Options) {
  const client = useApolloClient();
  const [changeDecision] = useChangeDecisionMutation({ client });

  const setDecisionBehavior: SetDecisionBehaviorFn = React.useCallback(
    async (itemId, value) => {
      const result = await changeDecision({
        variables: {
          input: {
            projectId,
            docId,
            itemId,
            values: {
              decisionSubitemsPreselection: [],
              decisionBehaviorOfSubitems: value,
            },
          },
        },
      });
      if (result.errors?.length) {
        throw new Error(result.errors[0].message);
      }
      if (!result.data) {
        throw new Error("Could not update decision behavior");
      }
    },
    [changeDecision, projectId, docId]
  );

  return { setDecisionBehavior };
}
